export default __webpack_public_path__ + "static/media/hugeicons_notification.d8e2906b.svg";